/**
 * Select Dropdown Renderer
 * Features: simple dropdown with static options
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { FieldRenderer } from '@/MyCode/core';

export const renderSelect: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => (
    <div className="space-y-2">
        <Label htmlFor={field.name}>
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
        <div className="w-full">
            <Select
                value={value || ''}
                onValueChange={(val) => handleChange(field.name, val)}
            >
                <SelectTrigger className={hasError ? 'w-full border-destructive' : 'w-full'}>
                    <SelectValue placeholder={field.placeholder || 'Select an option'} />
                </SelectTrigger>
                <SelectContent>
                    {field.options?.items?.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    </div>
);

export default renderSelect;